import PriceTab from "./PriceTab";

export default PriceTab;
